module.exports = __webpack_public_path__ + "img/102.5.e54ecbce.png";